import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import { router } from './error.routes';
import { ErrorComponent } from './error.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ErrorComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, router, TranslateModule]
})
export class ErrorModule {}



// WEBPACK FOOTER //
// ./src/app/modules/error/error.module.ts